import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export const ContainerStyled = styled.nav`
  margin-bottom: 45px;
`;

export const LinkStyled = styled(NavLink)`
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 40px;
  color: #7A8799 !important;
  padding: 10px 15px;

  &.active {
      color: #4A90E2 !important;
      border-bottom: 2px solid #4A90E2;
  }
  
  &:hover {
      text-decoration:none;
      color: #4A90E2 !important;
      border-bottom: 2px solid #4A90E2;
  }

  &:first-of-type {
      padding-left: 2px;
  }
`;